import { Link } from 'react-router-dom';
import { CITIES, SERVICES } from '@/data/content';
import * as Icons from 'lucide-react';
import { Seo } from '@/components/site/Seo';
import FinalCTA from '@/components/site/FinalCTA';

export default function ServiceAreas() {
  return (
    <div data-testid="page-service-areas">
      <Seo
        title="Service Areas — Fort Worth, Burleson & DFW | HearthOak"
        description="HearthOak Construction serves Fort Worth, Burleson, Weatherford, Granbury, Cleburne and surrounding DFW with owner-led home repair, painting and carpentry."
        path="/service-areas"
      />
      <section className="border-b border-brand-border bg-brand-bone">
        <div className="container-x py-14 lg:py-20">
          <div className="max-w-3xl">
            <div className="eyebrow mb-3">Service Areas</div>
            <h1 className="h1">Working across Fort Worth, Burleson, and DFW.</h1>
            <p className="body-lg mt-6">
              HearthOak Construction serves homeowners and property managers across the greater DFW area. Below is a look at the communities we work in most, and the kinds of projects that come up in each. Each community has its own page with local detail, common questions, and the services available there.
            </p>
          </div>
        </div>
      </section>

      <section className="surface-paper border-b border-brand-border">
        <div className="container-x py-16 lg:py-24 space-y-4">
          {CITIES.map((c) => (
            <article
              key={c.slug}
              className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-8 border border-brand-border bg-brand-bone p-8 lg:p-10"
              data-testid={`city-${c.slug}`}
            >
              <div>
                <Icons.MapPin size={20} className="text-brand-maroon" />
                <h2 className="mt-4 font-serif text-3xl text-brand-charcoal">{c.name}</h2>
                <span className="rule mt-4" />
                {c.intro && (
                  <Link
                    to={`/${c.slug}`}
                    className="mt-5 inline-flex items-center gap-2 font-sans text-xs uppercase tracking-[0.22em] text-brand-maroon hover:text-brand-charcoal transition-colors"
                    data-testid={`city-page-link-${c.slug}`}
                  >
                    {c.name} details <Icons.ArrowRight size={13} />
                  </Link>
                )}
              </div>
              <div>
                <p className="body-lg">{c.blurb}</p>
                <div className="mt-6">
                  <div className="eyebrow mb-3">Available in {c.name}</div>
                  <div className="flex flex-wrap gap-2">
                    {SERVICES.map((s) => (
                      <Link
                        key={s.slug}
                        to={`/services/${s.slug}`}
                        className="px-3 py-1.5 border border-brand-border text-xs uppercase tracking-wider font-sans text-brand-charcoal hover:bg-brand-charcoal hover:text-brand-bone transition-colors"
                      >
                        {s.title}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
